import { Content, Header, Page } from '@backstage/core-components';
import { Box, Typography } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import { ActivityConnectionPage } from './ControlPlaneActivityConnection';
import { useConnectionPageStyles } from './useConnectionPageStyles';

export const ControlPlaneConnectPage = () => {
  const classes = useConnectionPageStyles();
  const { activityId } = useParams<{ activityId: string }>();
  if (activityId) {
    return <ActivityConnectionPage key={activityId} activityId={activityId} />;
  }
  return (
    <Page themeId="tool">
      <Header
        title="Control Plane"
        subtitle="Prepare o workspace local e conecte o agente"
      />
      <Content>
        <Box className={classes.layout}>
          <Typography role="alert">Atividade não informada.</Typography>
        </Box>
      </Content>
    </Page>
  );
};
